import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {ProductsLotAbstract} from './products-lot-abstract';
import {ProductsMovementAbstract} from './products-movement-abstract';
import {ProductsArticle} from './products-article';

@Injectable()
export class ProductsAbstractService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private api_url_get_lot_abstract = './api/server.php?cmd=GET_LOT_ABSTRACT';
    private api_url_get_movement_abstract = './api/server.php?cmd=GET_MOVEMENT_ABSTRACT';

    private id_article: number;
    constructor(private http: Http) {}

    GetMovementAbstract(id_article: number): Promise<ProductsMovementAbstract[]> {
        this.id_article = id_article;
        return this.http.get(this.api_url_get_movement_abstract + '&id_article=' + this.id_article)
            .toPromise()
            .then(response => response.json() as ProductsMovementAbstract[])
            .catch(this.handleError);
    }

    GetLotAbstract(id_article: number): Promise<ProductsLotAbstract[]> {
        this.id_article = id_article;
        return this.http.get(this.api_url_get_lot_abstract + '&id_article=' + this.id_article)
            .toPromise()
            .then(response => response.json() as ProductsLotAbstract[])
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./src/app/products-abstract.service.ts